export const CARD_EXPIRED = 'card_expired';
export const CARD_NOT_VERIFIED = 'card_not_verified';
export const MERCHANT_UNSUPPORTED_CARD_BRAND = 'merchant_unsupported_card_brand';
export const MERCHANT_UNSUPPORTED_CARD_BRAND_TYPE = 'merchant_unsupported_card_brand_type';
export const PARTIAL_BILLING_ADDRESS = 'partial_billing_address';
export const UNSUPPORTED_BILLING_ADRESS = 'unsupported_billing_address';
export const UNSUPPORTED_CANADIAN_CARD = 'unsupported_canadian_card'; //Checks only debit card.
